/**
 * Create Audiences selectors — product page "Create Audiences" button and dialog
 * (task selection, count, model, Deep Research switch).
 */
export const AUDIENCE_GENERATION = {
  openButton: 'product-create-audiences-button',
  dialog: 'create-audiences-dialog',
  modelSelector: 'audience-generation-model-selector',   // existing literal — value must not change
  countInput: 'create-audiences-count-input',
  deepResearchSwitch: 'create-audiences-deep-research-switch',
  deepResearchCaption: 'create-audiences-deep-research-caption',
  selectAllCheckbox: 'create-audiences-select-all',
  taskRowPrefix: 'create-audiences-task-row-',
  taskRow: (taskId: string) => `create-audiences-task-row-${taskId}`,
  selectionSummary: 'create-audiences-selection-summary',
  submitButton: 'create-audiences-submit',
} as const;
